import { abrePDF } from "../../../utils/pdf";
import React, { useState, useEffect, useContext, useMemo } from "react";
import { fDMA } from "../../../utils/fecha";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import qrcode from "qrcode-js";
import { parse, v4 as uuidv4 } from "uuid";
import moment from "moment";


function ListadoFacturas() {
  const { user } = useContext(AuthContext);
  const URL_FACTURAS = process.env.REACT_APP_URL_FACTURAS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_TIMBRAR = process.env.REACT_APP_URL_TIMBRAR;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_COMP_PAGO = process.env.REACT_APP_URL_COMP_PAGO;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 90);
  
  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");

  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  // Desglose de complementos de pago aplicados a una factura
  const [modalComplementos, setModalComplementos] = useState(false);
  const toggleComplementos = () => setModalComplementos(!modalComplementos);
  const [complementos, setComplementos] = useState([]);
  const [facturaComp, setFacturaComp] = useState(null);
  const [cargandoComp, setCargandoComp] = useState(false);

  const fmtUSD = (v) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 2,
    }).format(Number(v) || 0);

  async function jalaComplementos(a) {
    setFacturaComp(a);
    setComplementos([]);
    setCargandoComp(true);
    setModalComplementos(true);
    try {
      const res = await axios.get(`${URL_COMP_PAGO}PorFactura/${a._id}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      });
      setComplementos(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.log("[complementos]", err);
      Swal.fire({
        icon: "error",
        title: "No se pudo cargar el desglose",
        text: err?.response?.data?.message || "",
      });
    } finally {
      setCargandoComp(false);
    }
  }

  function PDFComplementos() {
    if (!facturaComp) return;
    const doc = new jsPDF("landscape", "mm", "a4", true);
    const img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 240, 12, 35, 15);
    doc.text(`Complementos de Pago`, 15, 20);
    doc.text(
      `Factura ${facturaComp.serie || ""}-${facturaComp.folio || ""}  ·  ${facturaComp.clientes || ""}`,
      15,
      27
    );
    doc.text(
      `Total ${fmtUSD(facturaComp.total)}   Abonos ${fmtUSD(facturaComp.abonos)}   Saldo ${fmtUSD(facturaComp.saldo)}`,
      15,
      34
    );

    const vivos = complementos.filter((c) => !c.cancelado);
    const totalPagado = vivos.reduce((t, c) => t + Number(c.importe || 0), 0);

    doc.autoTable({
      head: [["Parc.", "Fecha", "Complemento", "Banco", "Forma", "UUID", "Saldo Anterior", "Importe", "Saldo Insoluto"]],
      body: complementos.map((c) => [
        c.cancelado ? `${c.parcialidad} (CANCELADO)` : c.parcialidad,
        fDMA(c.fecha),
        c.folio,
        c.banco,
        c.formaPago,
        c.uuid || "",
        fmtUSD(c.saldoAnterior),
        fmtUSD(c.importe),
        fmtUSD(c.saldoInsoluto),
      ]),
      headStyles: { fillColor: ["#B02307"], lineWidth: 0 },
      footStyles: { fillColor: ["#B02307"] },
      theme: "grid",
      startY: 40,
      styles: { fontSize: 7 },
      columnStyles: { 6: { halign: "right" }, 7: { halign: "right" }, 8: { halign: "right" } },
      foot: [
        [
          "", "", "", "", "", "",
          { content: "Total pagado", styles: { halign: "right" } },
          fmtUSD(totalPagado),
          "",
        ],
      ],
      showFoot: "lastPage",
    });

    abrePDF(doc, `Complementos-${facturaComp.serie || ""}-${facturaComp.folio || ""}.pdf`);
  }



  const [sucursales, setSucursales] = useState([]);
  const [selectedSucursal, setSelectedSucursal] = useState("");
  const [surtidos, setSurtidos] = useState([]);



  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useMemo(() => {
    axios
    .get(`${URL_FACTURAS}Fechas/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allFacturas = response.data;
        // Array para pagination
        let arrayTabla = allFacturas
          .sort((a, b) => (a.idFactura < b.idFactura ? 1 : -1))
          .map((a) => {
            return {
              _id: a._id,
              is_active: a.is_active,
              fecha: a.fecha,
              idFactura: a.idFactura,
              folio: a.folio,
              serie: a.serie,
              clientes: a.clientes[0].nombre_comercial,
              idClientes: a.clientes[0]._id,
              vendedores: a.colaboradores[0].nombre + " " + a.colaboradores[0].apellido,
              total: a.timbre === "No" ? 0 : a.total.toFixed(2),
              idFacturama: a.idFacturama,
              timbre: a.timbre,
              subTotal: a.timbre === "No" ? 0 : a.subTotal,
              iva: a.timbre === "No" ? 0 : a.iva,
              // Sin timbrar no se debe nada: todo en 0, igual que el total
              saldo: a.timbre === "No" ? 0 : a.saldo.toFixed(2),
              abonos: a.timbre === "No" ? 0 : a.total.toFixed(2) - a.saldo.toFixed(2),
              descuentoNumero1: a.descuentoNumero1,
              descuentoNumero2: a.descuentoNumero2,
              cadenaSAT: a.cadenaSAT,
            }
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        setComments(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [selectedFechaInicio, selectedFechaFin]);

  let totalImportePDF = 0;
  let subTotalPDF = 0;
  let totalIVAPDF = 0;

  function PDFTabla() {
    const data = comments
    .sort((a, b) => (a.folio > b.folio ? 1 : -1))
    .map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes) &&
        (a.folio != 0)
      ) {
        if(a.is_active == "Si"){
        totalImportePDF = parseFloat(totalImportePDF) + parseFloat(a.total);
        subTotalPDF = subTotalPDF + a.subTotal;
        totalIVAPDF = totalIVAPDF + a.iva;
        return [
          a.serie + a.folio,
          // a.numeroFactura,
          a.fecha,
          a.clientes,
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.subTotal),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.iva),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.total),
          // a.user,
        ]
      }else {
        return [
          a.serie + a.folio,
          // a.numeroFactura,
          a.fecha,
          a.clientes,
          "",
          "Cancelada",
          "",
          // a.user,
        ]
      }
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });

    const doc = new jsPDF();
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 150, 10, 33, 10);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 160, 23, 25, 25);
    doc.text(`Listado de Notas`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [["No.", "Fecha", "Cliente", "SubTotal", "IVA", "Total"]],
      body: dataPDFLimpia,
      startY: 50,
      foot: [
        [
          "",
          // "",
          "",
          "Totales",
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(subTotalPDF),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalIVAPDF),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalImportePDF),

        ]
      ],
      showFoot: "lastPage",
    });
    abrePDF(doc, `Facturas.pdf`);
  }

  function excel() {
    const dataExcel = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes)
      ) {
        if(a.is_active == "Si"){
        return {
          Folio:  a.serie + a.folio,
          Fecha: a.fecha,
          Cliente: a.clientes,
          SubTotal: a.subTotal,
          IVA: a.iva,
          Total: a.total,
          // Surtio: a.user,
        }
        }else{
          return {
            Folio:  a.serie + a.folio,
            // Factura: a.numeroFactura,
            Fecha: a.fecha,
            Cliente: a.clientes,
            SubTotal: 0,
            IVA: 0,
            Total: 0,
            // Surtio: a.user,
          }
        }
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoFacturas";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoFacturas",
        sheetFilter: ["Folio", "Fecha", "Cliente", "SubTotal", "IVA", "Total"],
        sheetHeader: ["Folio", "Fecha", "Cliente", "SubTotal", "IVA", "Total"],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes)
      ) {
        if(a.is_active == "Si"){
        totalImportePDF = totalImportePDF + a.total;
        subTotalPDF = subTotalPDF + a.subTotal;
        totalIVAPDF = totalIVAPDF + a.iva;
        return [
          a.idFactura,
          // a.numeroFactura,
          a.fecha,
          a.clientes,
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.subTotal),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.iva),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.total),
          // a.user,
        ]
      }else {
        return [
          a.idFactura,
          // a.numeroFactura,
          a.fecha,
          a.clientes,
          "",
          "Cancelada",
          "",
          // a.user,
        ]
      }
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF();
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 150, 10, 33, 10);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 160, 23, 25, 25);
    doc.text(`Listado de Notas`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [["No.", "Fecha", "Cliente", "SubTotal", "IVA", "Total"]],
      body: dataPDFLimpia,
      startY: 50,
      foot: [
        [
          "",
          // "",
          "",
          "Totales",
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(subTotalPDF),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalIVAPDF),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalImportePDF),

        ]
      ]
    });
    var att = doc.output("arraybuffer");
    var base64File = encode.encode(att, "base64");

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado de Facturas",
          email: mailTo,
          fileName: "ListadoFacturas.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Facturas.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }


  async function PDFOC(
    idFacturama,
    serie,
    folio
  ) {
    await axios
      .get(`${URL_TIMBRAR}ObtenerPDF/${idFacturama}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let facturaBase64 = response.data.respuesta.Content;
        
        const binaryData = atob(facturaBase64);
        
        const uint8Array = new Uint8Array(binaryData.length);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }
        
        const blob = new Blob([uint8Array], { type: "application/pdf" });
        
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `Factura${serie}-${folio}.pdf`;
        
        a.click();
        
        URL.revokeObjectURL(url);
        
        
      })
      .catch((err) => {
        console.log(err);
      });
  }
  
  async function PDFOCXML(
    idFacturama,
    serie,
    folio
  ) {
    await axios
      .get(`${URL_TIMBRAR}ObtenerXML/${idFacturama}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
      const facturaXMLBase64 = response.data.respuesta.Content;

      const facturaBlob = b64toBlob(facturaXMLBase64, 'application/xml');

      const dataURL = URL.createObjectURL(facturaBlob);

      const a = document.createElement('a');
      a.href = dataURL;
      a.download = `Factura${serie}-${folio}.xml`;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      function b64toBlob(base64, mimeType) {
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: mimeType });
      }

        
      })
      .catch((err) => {
        console.log(err);
      });
  }
  
  async function PDFOCXMLCANCELADA(
    id,
    serie,
    folio
  ) {
    await axios
      .get(`${URL_FACTURAS}/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let facturaXMLBase64 = response.data.respuestaFacturamaCancel[0].AcuseXmlBase64
        
      const facturaBlob = b64toBlob(facturaXMLBase64, 'application/xml');

      const dataURL = URL.createObjectURL(facturaBlob);

      const a = document.createElement('a');
      a.href = dataURL;
      a.download = `Factura${serie}-${folio}.xml`;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      function b64toBlob(base64, mimeType) {
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: mimeType });
      }

        
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const headers = [
    { name: "Numero", field: "idFactura", sortable: true },
    { name: "Fecha", field: "fecha", sortable: true },
    { name: "Cliente", field: "clientes", sortable: true },
    { name: "Vendedor", field: "vendedores", sortable: true },
    { name: "Folio", field: "folio", sortable: true },
    { name: "SubTotal", field: "subTotal", sortable: true },
    { name: "iva", field: "iva", sortable: true },
    { name: "Total", field: "total", sortable: true },
    { name: "Abonos", field: "abonos", sortable: true },
    { name: "Saldo", field: "saldo", sortable: true },
    { name: "Timbre", field: "timbre", sortable: true },
    { name: "Detalles", field: "acciones", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
          comment.vendedores.toLowerCase().includes(search.toLowerCase()) ||
          comment.timbre.toLowerCase().includes(search.toLowerCase()) ||
          comment.folio.toString().includes(search) ||
          comment.subTotal.toString().includes(search) ||
          comment.abonos.toString().includes(search) ||
          comment.saldo.toString().includes(search) ||
          comment.iva.toString().includes(search) ||
          comment.total.toString().includes(search)
      );
    }
    if (selectedCliente) {
      computedComments = computedComments.filter((e) =>
        e.idClientes.includes(selectedCliente)
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "folio"  &&
      sorting.field != "subTotal" &&
      sorting.field != "abonos" &&
      sorting.field != "saldo" &&
      sorting.field != "iva" &&
      sorting.field != "total"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "folio"  ||
      sorting.field == "subTotal"||
      sorting.field == "abonos"||
      sorting.field == "saldo"||
      sorting.field == "iva"||
      sorting.field == "total")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "folio"  ||
      sorting.field == "subTotal"||
      sorting.field == "abonos"||
      sorting.field == "saldo"||
      sorting.field == "iva"||
      sorting.field == "total")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedCliente,
    selectedFechaInicio,
    selectedFechaFin,
  ]);

  // function cancelarFactura(id, idFacturama, clientes, total) {
  //   Swal.fire({
  //     title: "Estas seguro?",
  //     text: "Se cancelara la Factura!",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#3085d6",
  //     cancelButtonColor: "#d33",
  //     confirmButtonText: "Si, Cancelar!",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
        
  //     toggleProgreso();
  //   axios
  //     .patch(`${URL_TIMBRAR}CancelFactura/${id}/${idFacturama}`, 
  //     {
  //       clientes,
  //       total
  //     },
  //     {
  //       headers: {
  //         Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  //       },
  //     })
  //     .then(() => {
  //       Swal.fire("Good job!", "Enviado con exito", "success");
  //       setTimeout(() => {
  //         window.location.reload();
  //       }, 1000);
  //     })
  //     .catch((error) => {
  //       Swal.fire({
  //         icon: "error",
  //         title: "Oops...",
  //         text: "Something went wrong!",
  //         footer: `${error.response.data}`,
  //       });
  //       console.log(error);
  //     });
  //   }
  // });
  // }

  function cancelarFactura(id, idFacturama, clientes, total, serie, folio) {
    Swal.fire({
      title: "¿Estás seguro?",
      text: "¡Se cancelará la factura!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, cancelar!",
    }).then((result) => {
      if (result.isConfirmed) {
        toggleProgreso();
  
        axios
          .patch(`${URL_TIMBRAR}CancelFactura/${id}/${idFacturama}`,
            {
              clientes,
              total,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {
            // LOG de cancelación exitosa
            axios.post(
              URL_LOGS,
              {
                tipo: "Cancelar Factura",
                detalle: `Factura ${serie} ${folio} cancelada`,
                user: user.id,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            );
  
            Swal.fire("¡Buen trabajo!", "Enviado con éxito", "success");
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "¡Algo salió mal!",
              footer: `${error.response?.data || "Error desconocido"}`,
            });
            console.log(error);
          });
      }
    });
  }
  



  return (
    <>
      <Header />
      <br />
      <br />
      {user.facturasFiscal ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
            <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  href="/FacturasCreate"
                >
                  Nueva Factura
                </Button>
              <Button
                size="sm"
                href="/MenuFiscal"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado de Facturas</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>

          {/* Desglose de complementos de pago de una factura */}
          <Modal
            size="xxl"
            isOpen={modalComplementos}
            toggle={toggleComplementos}
            style={{ maxWidth: "95%", margin: "0 auto" }}
          >
            <ModalHeader toggle={toggleComplementos}>
              <h4>
                Complementos de Pago — Factura {facturaComp?.serie} {facturaComp?.folio}
              </h4>
            </ModalHeader>
            <ModalBody>
              {facturaComp ? (
                <Row className="mb-3">
                  <Col md={4}>
                    <b>Cliente:</b> {facturaComp.clientes}
                  </Col>
                  <Col md={2}>
                    <b>Total:</b> {fmtUSD(facturaComp.total)}
                  </Col>
                  <Col md={2}>
                    <b>Abonos:</b> {fmtUSD(facturaComp.abonos)}
                  </Col>
                  <Col md={2}>
                    <b>Saldo:</b> {fmtUSD(facturaComp.saldo)}
                  </Col>
                  <Col md={2}>
                    {complementos.length > 0 ? (
                      <Button size="sm" color="danger" onClick={PDFComplementos}>
                        PDF <i class="far fa-file-pdf"></i>
                      </Button>
                    ) : null}
                  </Col>
                </Row>
              ) : null}

              {cargandoComp ? (
                <p>Cargando…</p>
              ) : complementos.length === 0 ? (
                <p>Esta factura no tiene complementos de pago.</p>
              ) : (
                <Table size="sm" striped borderless className="table-responsive-xl">
                  <thead>
                    <tr align="center">
                      <th className="tituloTabla">Parc.</th>
                      <th className="tituloTabla">Fecha</th>
                      <th className="tituloTabla">Complemento</th>
                      <th className="tituloTabla">Banco</th>
                      <th className="tituloTabla">Forma Pago</th>
                      <th className="tituloTabla">UUID</th>
                      <th className="tituloTabla">Saldo Anterior</th>
                      <th className="tituloTabla">Importe</th>
                      <th className="tituloTabla">Saldo Insoluto</th>
                    </tr>
                  </thead>
                  <tbody>
                    {complementos.map((c, i) => (
                      <tr
                        key={c._id || i}
                        style={c.cancelado ? { backgroundColor: "#ed8c8c" } : undefined}
                      >
                        <td align="center">{c.parcialidad}</td>
                        <td align="center">{fDMA(c.fecha)}</td>
                        <td align="center">
                          {c.folio}
                          {c.cancelado ? <b> (CANCELADO)</b> : null}
                        </td>
                        <td align="center">{c.banco}</td>
                        <td align="center">{c.formaPago}</td>
                        <td align="center" style={{ fontSize: 11 }}>
                          {c.uuid || "—"}
                        </td>
                        <td align="right">{fmtUSD(c.saldoAnterior)}</td>
                        <td align="right">{fmtUSD(c.importe)}</td>
                        <td align="right">{fmtUSD(c.saldoInsoluto)}</td>
                      </tr>
                    ))}
                    <tr>
                      <td colSpan={7} className="negrita" align="right">
                        Total pagado con complementos
                      </td>
                      <td className="negrita" align="right">
                        {fmtUSD(
                          complementos
                            .filter((c) => !c.cancelado)
                            .reduce((t, c) => t + Number(c.importe || 0), 0)
                        )}
                      </td>
                      <td></td>
                    </tr>
                  </tbody>
                </Table>
              )}

              {complementos.some((c) => c.cancelado) ? (
                <small className="text-muted">
                  Los renglones en rojo son complementos cancelados: se muestran como
                  antecedente pero no suman al total ni al saldo de la factura.
                </small>
              ) : null}
            </ModalBody>
            <ModalFooter>
              <Button color="success" onClick={toggleComplementos}>
                Cerrar
              </Button>
            </ModalFooter>
          </Modal>

          <h3 align="center">Facturas</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label>Clientes</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedCliente}
                onChange={(e) => {
                  setSelectedCliente(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="0">Selecciona</option>
                {clientes
                  .sort((a, b) =>
                    a.nombre_comercial > b.nombre_comercial ? 1 : -1
                  )
                  .map((a) => {
                    return <option value={a._id}>{a.nombre_comercial}</option>;
                  })}
              </Input>
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((a) => {
                if(a.is_active == "No"){
                  return (
                    <tr style={{ backgroundColor: "#ed8c8c"}}>
                      <td>{a.idFactura}</td>
                      <td>{fDMA(a.fecha)}</td>
                      <td>{a.clientes}</td>
                      <td>{a.vendedores}</td>
                      <td>{a.serie} {a.folio}</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>CANCELADA</td>
                      <td></td>
                      <td>
                      <>
                            <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) =>
                                PDFOC(
                                  a.idFacturama,
                                  a.serie,
                                  a.folio
                                )
                              }
                            >
                              <i class="far fa-file-pdf"></i>
                            </Button>
                      <Button
                              size="sm"
                              className="btn"
                              color="info"
                              onClick={(e) =>
                                PDFOCXMLCANCELADA(
                                  a._id,
                                  a.serie,
                                  a.folio
                                )
                              }
                            >
                            <i class="fas fa-file-alt"></i>
                            </Button>
                      </>
                      </td>
                    </tr>
                  );
                }else{
                  // totalImporteTabla = totalImporteTabla + a.total_general;
                  // subTotalTabla = subTotalTabla + a.subTotal;
                  // totalIVATabla = totalIVATabla + a.iva;
                  return (
                    <tr>
                       <td>{a.idFactura}</td>
                      <td>{fDMA(a.fecha)}</td>
                      <td>{a.clientes}</td>
                      <td>{a.vendedores}</td>
                      <td>{a.serie} {a.folio}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.subTotal)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.iva)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.total)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.abonos)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.saldo)}</td>
                      <td>{a.timbre}</td>
                      <td>
                        {a.timbre == "Si" ? (
                          
                          <>
                            <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) =>
                                PDFOC(
                                  a.idFacturama,
                                  a.serie,
                                  a.folio
                                )
                              }
                            >
                              <i class="far fa-file-pdf"></i>
                            </Button>

                            <Button
                              size="sm"
                              className="btn"
                              color="info"
                              onClick={(e) =>
                                PDFOCXML(
                                  a.idFacturama,
                                  a.serie,
                                  a.folio
                                )
                              }
                            >
                              <i class="fas fa-file-alt"></i>
                            </Button>

                            {/* Desglose de los complementos de pago de esta factura */}
                            <Button
                              size="sm"
                              className="btn"
                              color="success"
                              title="Complementos de pago"
                              onClick={(e) => jalaComplementos(a)}
                            >
                              <i class="fas fa-receipt"></i>
                            </Button>
                              {a.saldo == a.total ? (
                                <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) => cancelarFactura(a._id, a.idFacturama, a.idClientes, a.total, a.serie, a.folio)}
                            >
                              <i class="fas fa-ban"></i>
                            </Button>
                              ) : (
                                <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              disabled
                            >
                              <i class="fas fa-ban"></i>
                            </Button>
                              )}
                            
                          </>
                        ): undefined}
                      </td>
                    </tr>
                  );
                }

              })}
              {/* <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita" align="center">
                  TOTAL
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(subTotalTabla)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalIVATabla)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalImporteTabla)}
                </td>
                <td></td>
              </tr> */}
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>


          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>

        </div>
      ) : undefined}
      <br />
      {loader}
    </>
  );
}

export default ListadoFacturas;
